import React, { useEffect, useMemo, useState } from 'react';
import { Drawer } from '@mui/material';
import { NavigationMenuItem } from '../../../../../models/NavigationMenuItem';
import useMobileMenu from '../../../../../hooks/useMobileMenu';
import useShopifyMenuSWR from '../../../../../hooks/shopify/useShopifyMenuSWR';
import { MobileNavigationItemWrapper } from './MobileNavigationItemWrapper';

export const CollectionMobileDrawer = () => {
    const { menuItems, isLoading, isError, forceRefresh } =
        useShopifyMenuSWR('main-menu');
    const mobileMenu = useMobileMenu();
    const [selectedMenuIds, setSelectedMenuIds] = useState<string[]>([]);

    const toggleDrawer =
        (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
            if (
                event.type === 'keydown' &&
                ((event as React.KeyboardEvent).key === 'Tab' ||
                    (event as React.KeyboardEvent).key === 'Shift')
            ) {
                return;
            }

            mobileMenu.showMainMenu(open);
        };

    const findCurrentMenu = (id: string, menuItems) => {
        for (let menu of menuItems) {
            if (menu.id === id) return menu;
            if (menu.items && menu.items.length > 0) {
                const result = findCurrentMenu(id, menu.items);
                if (result) return result;
            }
        }
    };

    const nextCollection = (menuItem) => {
        if (menuItem.items && menuItem.items.length > 0) {
            setSelectedMenuIds([...selectedMenuIds, menuItem.id]);
        }
    };

    const prevCollection = () => {
        setSelectedMenuIds((prev) => prev.slice(0, -1));
    };

    const menuItemClicked = (
        isParent: boolean,
        menuItem: NavigationMenuItem
    ) => {
        if (isParent) {
            prevCollection();
        } else {
            nextCollection(menuItem);
        }
    };

    useEffect(() => {
        setSelectedMenuIds(['main-menu']);
    }, [isLoading]);

    const currentMenu = useMemo(() => {
        if (selectedMenuIds.length < 1 || !menuItems) return;
        const historyElement = selectedMenuIds[selectedMenuIds?.length - 1];
        return findCurrentMenu(historyElement, [menuItems]);
    }, [findCurrentMenu, selectedMenuIds, menuItems]);

    if (isLoading || isError) {
        return <></>;
    }

    return (
        <>
            <Drawer
                anchor={'left'}
                open={mobileMenu.mobileMenuStates.main.open}
                onClose={toggleDrawer(false)}
            >
                <MobileNavigationItemWrapper
                    clickHandler={menuItemClicked}
                    menuItems={currentMenu}
                />
            </Drawer>
        </>
    );
};
